import { jsx as _jsx } from "react/jsx-runtime";
import MuiTypography from '@mui/material/Typography';
import * as React from 'react';
import { Skeleton } from '../skeleton';
import { usePaletteColor } from '../theme';
import { withVersion } from '../utils';
export * from './measure';
export * from './with-tooltip';
export const typographyVariants = [
    'headingLarge',
    'headingMedium',
    'headingSmall',
    'bodyDefault',
    'bodyEmphasis',
    'bodyStrong',
    'detail',
    'code'
];
export const typographyTextTransforms = [
    'none',
    'capitalize',
    'uppercase',
    'lowercase',
    'sentence',
    'full-width',
    'full-size-kana',
    'inherit',
    'initial',
    'unset',
    'revert',
    'revert-layer',
    'unset'
];
const TypographyImpl = React.forwardRef(({ variant, align = 'left', maxWidth = '100%', color, bgcolor, display, height, flex, fontSize, fontStyle, fontWeight, gridColumn, lineHeight, lineClamp, marginBottom, marginLeft, marginTop, minWidth, minHeight, mt, mb, ml, mr, px, py, letterSpacing, overflow, paddingLeft, textTransform, textAlign, textOverflow, whiteSpace, visibility, borderRadius, skeleton, children, ...muiProps }, ref) => {
    const paletteColor = usePaletteColor(color);
    const cssLineClamp = (() => {
        if (lineClamp) {
            return getSxLineClamp(lineClamp);
        }
        return undefined;
    })();
    const cssTextTransform = textTransform === 'sentence' ? undefined : textTransform;
    const resolvedVariant = variant ?? 'body2';
    const component = (_jsx(MuiTypography, { ref: ref, variant: resolvedVariant, variantMapping: {
            headingLarge: 'h2',
            headingMedium: 'h3',
            headingSmall: 'h4',
            bodyDefault: 'p',
            bodyEmphasis: 'p',
            bodyStrong: 'p',
            detail: 'span',
            code: 'code'
        }, align: align, ...muiProps, sx: {
            fontFamily: (theme) => theme.typography.fontFamily,
            color: paletteColor,
            bgcolor,
            display,
            height,
            flex,
            fontSize,
            fontWeight,
            fontStyle,
            gridColumn,
            lineHeight,
            marginBottom,
            marginLeft,
            marginTop,
            maxWidth,
            minWidth,
            minHeight,
            mt,
            mb,
            mr,
            ml,
            px,
            py,
            letterSpacing,
            overflow,
            paddingLeft,
            textAlign,
            textOverflow: textOverflow ?? 'ellipsis',
            textTransform: cssTextTransform,
            whiteSpace,
            visibility,
            borderRadius,
            ...cssLineClamp,
            ...muiProps.sx
        }, children: prepareTextTransform(children, textTransform) }));
    if (skeleton) {
        return (_jsx(Skeleton, { ...(typeof skeleton === 'object' ? skeleton : {}), children: component }));
    }
    return component;
});
export const Typography = withVersion(TypographyImpl, '1.0.0');
export function getSxLineClamp(lines) {
    return {
        lineClamp: `${lines}`,
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical'
    };
}
export const firstLetterUppercase = {
    ':first-letter': { textTransform: 'uppercase' }
};
export const prepareTextTransform = (element, textTransform) => {
    if (textTransform !== 'sentence') {
        return element;
    }
    return sentence(element);
};
export const sentence = (element) => {
    if (!element) {
        return element;
    }
    if (typeof element === 'string') {
        return `${element[0].toUpperCase()}${element.slice(1)}`;
    }
    return element;
};
